import * as React from "react";
import { OpenChatMessage } from "@/types/open-chat";
import { OpenChatMessageRowUser } from "./messageRowUser";
import { OpenChatMessageRowAi } from "./messageRowAi";

interface Props {
  message: OpenChatMessage;
  isImprovement?: boolean;
  allowImprovement?: boolean;
  allowCopy?: boolean;
  onImprovePrompt?: () => void;
  hideIcons?: boolean;
  className?: string;
}

export const OpenChatMessageRow: React.FC<Props> = ({
  onImprovePrompt,
  message,
  allowCopy,
  className,
  isImprovement,
  allowImprovement,
  hideIcons,
}) =>
  message.type === "human" ? (
    <OpenChatMessageRowUser
      hideIcons={hideIcons}
      allowImprovement={allowImprovement}
      message={message}
      onImprovePrompt={onImprovePrompt}
      className={className}
    />
  ) : (
    <OpenChatMessageRowAi hideIcons={hideIcons} message={message} allowCopy={allowCopy} isImprovement={isImprovement} />
  );
